import React, { useRef, useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useSpring, useTransform, useMotionValue }from "framer-motion";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import Header from '../components/common/Header.jsx';
import Footer from '../components/common/Footer.jsx';
import Counter from '../components/common/Counter';
import '../styles/common/Homepage.css';

import bannerMain from '../assets/homepage/banner-main.svg';
import hero from '../assets/homepage/hero.svg';
import icon1 from '../assets/homepage/icon1.png';
import icon2 from '../assets/homepage/icon3.svg';
import icon3 from '../assets/homepage/icon4.png';
import icon4 from '../assets/homepage/icon5.svg';
import icon5 from '../assets/homepage/icon6.svg';
import icon6 from '../assets/homepage/icon7.svg';
import icon7 from '../assets/homepage/icon8.svg';
import icon8 from '../assets/homepage/icon9.png';
import icon9 from '../assets/homepage/icon10.svg';
import icon10 from '../assets/homepage/icon11.png';
import icon11 from '../assets/homepage/icon12.png';
import icon12 from '../assets/homepage/icon2.png';

import pizza from '../assets/homepage/pizza.png';
import pencil from '../assets/homepage/pencil.png';
import goal from '../assets/homepage/goal.png';

import rocket from '../assets/homepage/rocket.png';
import face from '../assets/homepage/face.png';
import plane from '../assets/homepage/plane.png';
import cake from '../assets/homepage/cake.png';

import edera from '../assets/homepage/edera.svg';
import mon from '../assets/homepage/mon.svg';
import tokarev from '../assets/homepage/tokarev.png';

import fish from '../assets/homepage/fish.svg';

import footerImg from '../assets/homepage/footer1.svg';

const icons = [
  { id: 1, src: icon1, x: '-20%', y: '25%', size: 10, duration: 3, delay: 0 }, 
  { id: 2, src: icon2, x: '-35%', y: '15%', size: 14, duration: 4, delay: 1 }, 
  { id: 3, src: icon3, x: '-25%', y: '-10%', size: 12, duration: 3.5, delay: 0.5 },
  { id: 4, src: icon4, x: '-15%', y: '-20%', size: 8, duration: 4.2, delay: 2 },
  { id: 5, src: icon5, x: '-15%', y: '-30%', size: 15, duration: 3.8, delay: 1.2 },
  { id: 6, src: icon6, x: '10%', y: '-30%', size: 11, duration: 3.2, delay: 0.8 },
  { id: 7, src: icon7, x: '20%', y: '-15%', size: 13, duration: 4.5, delay: 0.3 },
  { id: 8, src: icon8, x: '30%', y: '0%', size: 9, duration: 3.7, delay: 1.5 },
  { id: 9, src: icon9, x: '22%', y: '10%', size: 16, duration: 4, delay: 0.7 },
  { id: 10, src: icon10, x: '35%', y: '20%', size: 12, duration: 3.4, delay: 1.1 },
  { id: 11, src: icon11, x: '25%', y: '25%', size: 10, duration: 4.1, delay: 0.4 },
  { id: 12, src: icon12, x: '-25%', y: '10%', size: 10, duration: 4.1, delay: 0.4 }
];

const statCards = [
  { id: 1, src: pizza, duration: 1.5, bgColor: '#E95E2A', color: '#FFF', bigText: '12', topText: 'учнів не розуміють, що таке 1/4 піци', bottomText: 'Саме стільки учасників НМТ-2025 не відповіли на запитання рівня 5–7 класу.' },
  { id: 2, src: pencil, duration: 3, bgColor: '#F1F458', color: '#1E1E1E', bigText: '42', topText: 'не знають, як розрахувати час на дорогу чи оцінити вигоду від знижки.', bottomText: 'Саме стільки підлітків не досягли базового рівня з математики (PISA 2022)' },
  { id: 3, src: goal, duration: 0.8, bgColor: '#4C532D', color: '#FFF', bigText: '3', topText: 'школярів досягає високих балів з математики', bottomText: 'Це лише кожен 33-й учень (PISA-2022)' },
];

const slides = [
    {
      id: 1,
      title: "У вчителів:",
      sender1: "Завуч",
      text1: "Наталю, вибач, форс-мажор. Оксана захворіла. А зможеш завтра підхопити 6-Б? 🙏",
      sender2: "Вчителька математики",
      text2: "Та без питань. Візьму БігМат.",
      color: "orange"
    },
    {
      id: 2,
      title: "У батьків:", 
      sender1: "Мама Сергія",
      text1: "Постійно сваримося через математику — геть вчитися не хоче",
      sender2: "Мама Сашка",
      text2: "Ой, а ми як почали разом на БігМат уроки проходити, то це тепер улюблений предмет. Може, теж спробуєте?",
      color: "blue"
    },
    {
      id: 3,
      title: "У школярів:",
      sender1: "Дарина",
      text1: "Через грип пропустила уроки, тепер геть не розумію домашку 🥹",
      sender2: "Надя",
      text2: "А ти пробувала на БігМат позайматися?",
      color: "pink"
    }
  ];

  const companiesLogos = [
    {
      id: 1,
      src: edera,
      width: '90px'
    },
    {
      id: 2,
      src: mon,
      width: '230px'
    },
    {
      id: 3,
      src: tokarev,
      width: '125px'
    }
  ] 

  function useMouseParallax(strength = 1) {
    const mouseX = useMotionValue(0);
    const mouseY = useMotionValue(0);

    const smoothX = useSpring(mouseX, { stiffness: 50, damping: 20 });
    const smoothY = useSpring(mouseY, { stiffness: 50, damping: 20 });

    useEffect(() => {
      const handleMouseMove = (e) => {
        const x = (e.clientX / window.innerWidth - 0.5) * strength;
        const y = (e.clientY / window.innerHeight - 0.5) * strength;
        
        mouseX.set(x);
        mouseY.set(y);
      };

      window.addEventListener("mousemove", handleMouseMove);
      return () => window.removeEventListener("mousemove", handleMouseMove);
    }, [strength, mouseX, mouseY]);

    return { x: smoothX, y: smoothY };
  }

export default function HomePage() {

  const scrollReveal = {
    offscreen: { 
      y: 60, 
      opacity: 0 
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.3,
        duration: 1
      }
    }
  };

  const sectionRef = useRef(null);

  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const range = useMemo(() => (isMobile ? 120 : 350), [isMobile]);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  const smoothProgress = useSpring(scrollYProgress, { 
    stiffness: 50,
    damping: 20
  });

  const y1 = useTransform(
    smoothProgress, 
    [0, 1], 
    isMobile ? [range*1.5, -range] : [-range, range]
  );

  const y2 = useTransform(
    smoothProgress, 
    [0, 1], 
    isMobile ? [range*1.5, -range] : [-range, range]
  );

  const y3 = useTransform(
    smoothProgress, 
    [0, 1], 
    isMobile ? [range*1.5, -range] : [range, -range]
  );

  const y4 = useTransform(
    smoothProgress, 
    [0, 1], 
    isMobile ? [range*1.5, -range] : [range, -range]
  );

  const mouse = useMouseParallax(0);


  const handleScroll = (e) => {
    e.preventDefault();
    const element = document.getElementById('cards');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <div className="page-container homepage">
      <Header />
      
      <div className="homepage__banner" style={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative', 
        overflow: 'hidden',
        width: '100%',
      }}>
        <h1 className="homepage__title">БігМат</h1>
        <p className="homepage__subtitle">
          Платформа зрозумілої математики, де ви знайдете безоплатний застосунок для дітей, 
          методичні матеріали  для вчителів та поради для батьків, як&nbsp;пояснити математику, 
          яка навколо.
        </p>

        <div className="banner__wrapper" style={{ 
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          marginTop: '60px'
        }}>
          
          {icons.map((icon) => (
            <img
              key={icon.id}
              src={icon.src}
              className="levitating-icon"
              alt=""
              style={{
                marginLeft: icon.x,
                marginTop: icon.y,
                animationDuration: `${icon.duration}s`,
                animationDelay: `${icon.delay}s`
              }}
            />
          ))}

          <img 
            className="banner__img" 
            src={bannerMain} 
            alt="БігМат"
            style={{ 
              position: 'relative', 
              zIndex: 2,
              width: '100%',
              maxWidth: '480px',
              height: 'auto'
            }} 
          />
          <div className="banner__start-btn" onClick={handleScroll}>Нумо розбиратися</div>
        </div>
      </div>

      <motion.section 
        className="home__section math-stats"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={scrollReveal}
      >
        <h2 className="home__section-title">Математика, яку ми втрачаємо</h2>
        <p className="section__text">
          Математику часто не люблять, не розуміють і навіть бояться.
        </p>
        <div className="math-stats__cards">
          {statCards.map((card) => (
            <div 
              className="math-stats__card"
              key={card.id}
              style={{ background: card.bgColor, color: card.color }}
            >
              <div>
                <p className="math-stats__num">
                  <Counter value={card.bigText} duration={card.duration} /><sup>%</sup>
                </p>
                <p>
                  <b>{card.topText}</b>
                </p>
              </div>
              <p>{card.bottomText}</p>
              <img src={card.src} alt=""/>
            </div>
          ))}
        </div>
      </motion.section>

      <motion.section 
        className="home__section math-inspire"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={scrollReveal}
      >
        <div className="math-inspire__title-container">
          <h2 className="home__section-title">
            БігМат — математика навколо
          </h2>
          <svg className="home__sticker-arrow" width="68" height="84" viewBox="0 0 68 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M53.2795 73.9756L34.3772 77.7531L30.601 58.8533" stroke="#1E1E1E" strokeWidth="4" strokeMiterlimit="10"/>
            <path d="M27.2302 1.78136C27.2302 1.78136 67.6008 34.0531 34.5485 77.0709" stroke="#1E1E1E" strokeWidth="4" strokeMiterlimit="10"/>
          </svg>
        </div>
        <div className="math-inspire__container">
          <img src={hero} alt=""/>
          <div className="math-inspire__comment">
            Розуміння математики — це не про бали у журналі. А про фінансову грамотність, критичне мислення, інтерес до STEM і&nbsp;майбутню конкурентоспроможність та&nbsp;технологічну перемогу країни.
          </div>
        </div>
      </motion.section >

      <motion.section 
        className="home__section users-cards"
        id="cards"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={scrollReveal}
      >
        <div className="user-cards__card-item user-cards__card-item_yellow">
          <div className="card-content">
            <h3>Учням</h3>
            <p>Розуміють, для чого вчити</p>
            <Link className="user-card__btn" to="/theme/fractions">Почати вчитися</Link>
          </div>
        </div>

        <div className="user-cards__card-item user-cards__card-item_orange">
          <div className="card-content">
            <h3>Учителям</h3>
            <p>Розуміють, як навчати</p>
            <Link className="user-card__btn user-card__btn_yellow" to="/teachers">Розібратися в&nbsp;інструментах</Link>
          </div>
        </div>

        <div className="user-cards__card-item user-cards__card-item_blue">
          <div className="card-content">
            <h3>Батькам</h3>
            <p>Розуміють, як підтримати</p>
            <Link className="user-card__btn btn-dark" to="/parents">Зрозуміти, <br/>як допомогти</Link>
          </div>
        </div>
      </motion.section >

      <motion.section 
        className="home__section features-circle"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={scrollReveal}
        style={{ perspective: 1000 }}
      >
        <div className="features-circle__container">
          <div className="features-circle__center">
            <h2 className="features-circle__title">
              Коли математика <br/>
              не лякає,<span className="home__sticker-note">а надихає</span>
            </h2>
          </div>

        <motion.img
          className="features-circle__img rocket"
          src={rocket} alt=""
          style={{ x: useTransform(mouse.x, (v) => v * -1.5), y: useTransform(mouse.y, (v) => v * -1.5) }}
        />
        <motion.img
          className="features-circle__img cake"
          src={cake} alt=""
          style={{ x: useTransform(mouse.x, (v) => v * 0.8), y: useTransform(mouse.y, (v) => v * 0.8) }}
        />
        <motion.img
          className="features-circle__img face"
          src={face} alt=""
          style={{ x: useTransform(mouse.x, (v) => v * -0.5), y: useTransform(mouse.y, (v) => v * -0.5) }}
        />
        <motion.img
          className="features-circle__img plane"
          src={plane} alt=""
          style={{ x: useTransform(mouse.x, (v) => v * 2.5), y: useTransform(mouse.y, (v) => v * 2.5) }}
        />

        <motion.div
          className="features-circle__item features-circle__item--1"
          style={{ y: y1 }}
        >
          <h3 className="features-circle__item-title">Математика для життя</h3>
          <p className="features-circle__item-text">Не дроби, а скільки шматочків торта потрібно підготувати на день народження для друзів.</p>
        </motion.div>

        <motion.div
          className="features-circle__item features-circle__item--2"
          style={{ y: y2 }}
        >
          <h3 className="features-circle__item-title">Інтерактивні модулі</h3>
          <p className="features-circle__item-text">Не зубріння підручника чи перегляд відео на x2, а навчальні пригоди: граєш, думаєш, розв'язуєш і нарешті розумієш.</p>
        </motion.div>

        <motion.div
          className="features-circle__item features-circle__item--3"
          style={{ y: y3 }}
        >
          <h3 className="features-circle__item-title">Підтримка для вчителів</h3>
          <p className="features-circle__item-text">Не безсонні ночі, а сучасні навчальні інструменти й методологічні поради.</p>
        </motion.div>

        <motion.div
          className="features-circle__item features-circle__item--4"
          style={{ y: y4 }}
        >
          <h3 className="features-circle__item-title">Інструменти для батьків</h3>
          <p className="features-circle__item-text">Не «поки не зробиш уроки», а «о, я знаю, як це пояснити» чи «пограймо».</p>
        </motion.div>

        </div>
      </motion.section>

      <motion.section 
        className="home__section chat-section"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={scrollReveal}
      >
        <h2 className="home__section-title">Надолужуємо з&nbsp;математикою</h2>
        <div className="chat-slider-container">
          
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              nextEl: '.chat-button-next',
              prevEl: '.chat-button-prev',
            }}
            className="chat-swiper"
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className="chat-slide">
                  <h2 className="chat-slide__header">{slide.title}</h2>
                  
                  <div className="chat-viewport">
                    <div className="bubble bubble--white">
                      <span className="bubble__sender bubble__sender--dark">{slide.sender1}</span>
                      <p className="bubble__text">{slide.text1}</p>
                    </div>

                    <div className={`bubble bubble--${slide.color} bubble--bottom`}>
                      <span className="bubble__sender bubble__sender--light">{slide.sender2}</span>
                      <p className="bubble__text">{slide.text2}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button className="chat-nav-btn chat-button-prev" aria-label="Назад">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
          <button className="chat-nav-btn chat-button-next" aria-label="Вперед">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>

        </div>
        <div className="chat-section__join-btn" onClick={handleScroll}>Долучитися</div>
      </motion.section >

      <motion.section 
        className="home__section companies"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={scrollReveal}
      >
        <h2 className="home__section-title">Хто вболіває за математику</h2>
        <div className="companies__logos">
          {companiesLogos.map((logo, index) => (
            <img key={logo.id} src={logo.src} style={{width: logo.width}} alt=""/>
          ))}
        </div>
        <div className="companies__text">
          <p>
            БігМат — це спільний проєкт студії онлайн-освіти EdEra та організації технологічної філантропії Tokarev Foundation. Ми віримо, що кожна дитина може навчатися з радістю і досягати результатів. 
          </p>
          <p>
            А ще ми підписали Меморандум про співпрацю з Міністерством освіти і науки України — будемо разом покращувати якість математичної освіти.
          </p>
        </div>
        <div className="companies__btn">
          <img src={fish} alt=""/>
          <Link className="chat-section__join-btn">Долучитися до проєкту</Link>
        </div>
      </motion.section >

      <motion.section 
        className="home__section results"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={scrollReveal}
      >
        <h2 className="home__section-title">Наші результати через 3&nbsp;роки</h2>
        <p className="home__section-subtitle">Зухвало, але нам подобається.</p>
        
        <div className="results__container">
          <div className="results__card">
            <div className="results__card--top">
              <p><Counter value={20} duration={1.5} /><sup>%</sup></p>
              <p>українських шкіл</p>
            </div>
            <p>інтегрували нашу платформу</p>  
          </div>

          <div className="results__card">
            <div className="results__card--top">
              <p><Counter value={4} duration={2} /><sup>млн</sup></p>
              <p>учнів</p>
            </div>
            <p>стали нашими постійними користувачами</p>  
          </div>

          <div className="results__card">
            <div className="results__card--top">
              <p>+<Counter value={10} duration={1.2} /><sup>%</sup></p>
              <p>учнів</p>
            </div>
            <p>досягли базового рівня в тестуванні PISA</p>  
          </div>

          <div className="results__card">
            <div className="results__card--top">
              <p>-<Counter value={10} duration={1.2} /><sup>%</sup></p>
              <p>розриву</p>
            </div>
            <p>між найуспішнішими учнями й тими, кому математика дається важко</p>  
          </div>
        </div>
      </motion.section>
      <Footer 
        image={footerImg} 
        text="Коли математика не лякає, а надихає" 
        shouldDecorate={true} 
      />
    </div>
  );
}